import { render, staticRenderFns } from "./DashboardClient.vue?vue&type=template&id=6874e800&"
import script from "./DashboardClient.vue?vue&type=script&lang=js&"
export * from "./DashboardClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports